import { LogoWithTitle } from 'pages/our-story/components/LogoWithTitle'
import { sectionTitleTextStyles } from 'pages/our-story/OurStoryPage'

export const Section1 = () => {
  return (
    <>
      <div className='flex flex-col text-left gap-10'>
        {/* Group Logo */}
        <LogoWithTitle title='Group' />

        {/* Heading */}
        <h1 className='text-lg font-bold text-[#001A3D] leading-6 tracking-[0.4px] lg:text-[32px] 3xl:text-[64px] 3xl:leading-normal'>
          Getting legal professions to work for everyone.
        </h1>

        {/* Subheading */}
        <h2 className={sectionTitleTextStyles}>
          We use <span className='text-[#6596D7]'>technology</span> and data to
          help people make{' '}
          <span className='text-[#6596D7]'>better decisions</span> about{' '}
          <span className='text-[#6596D7]'>legal services.</span>
        </h2>

        {/* Body */}
        <p className='text-sm text-[#001A3D] font-medium lg:text-lg'>
          We do this by understanding people’s legal needs, leveraging market
          data to match them with the right lawyer and provide unique insights
          into the legal professions.
        </p>
      </div>
    </>
  )
}
